/* 
  일자    : 2020.03.05
  작성자  : 오순영
  내용    : 조직도
*/

const state = {
  m_checkList: [], // 체크된 리스트(전체 체크시 사용)
  m_selectedMembers: [] // 선택대상
};

const actions = {
  /* 조직도 선택 > 선택대상 추가 */
  addSelect(context, payload) {
    for (let i = 0; i < payload.checked.length; i++) {
      const el = payload.checked[i];
      if (payload.selectedMembers.includes(el)) {
        // alert(el.userName + " 팀원은 이미 존재합니다.");
        alert(this.$t("message.organizationjs.001", "{name} 팀원은 이미 존재합니다.", {name: el.userName}))
      } else {
        payload.selectedMembers.push(el);
      }
    }
    context.commit("setSelectMember", payload.selectedMembers);
  },
  /* 선택대상 선택 > 선택대상 삭제 */
  delSelect(context, payload) {
    for (let i = 0; i < payload.checked.length; i++) {
      const el = payload.checked[i];
      payload.selectedMembers = payload.selectedMembers.filter(users => users.userId !== el.userId);
    }
    context.commit("setSelectMember", payload.selectedMembers);
  },
  /* 선택대상 초기화 */
  resetSelected(context) {
    context.commit("resetSelectedMember");
  },
  /* 전체 체크/해제 설정 */
  setCheck(context, payload) {
    let checks = [];
    if (payload.isCheck) {
      payload.data.forEach(user => {
        checks.push(user);
      });
      payload.checked = checks;
    } else {
      payload.checked = [];
    }
    context.commit("setAllCheck", payload.checked);
  }
};

const mutations = {
  /* 선택대상 설정 */
  setSelectMember(state, selectedMembers) {
    state.m_selectedMembers = selectedMembers;
  },
  /* 선택대상 초기화 */
  resetSelectedMember(state) {
    state.m_selectedMembers = [];
  },
  /* 전체 체크/해제 설정 */
  setAllCheck(state, checked) {
    state.m_checkList = checked;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/js/store/modules/organization.js